import React from 'react';
import { SiteContextProvider, client } from '@provider';
import { ApolloProvider } from '@apollo/client';
import { ReactNode } from 'react';
import { Framework } from '@components';
import { AnimatePresence } from 'motion/react';

export const wrapRootElement = ({ element }: {element: ReactNode}) => (
	<ApolloProvider client={client}>
		<SiteContextProvider>
				{element}
		</SiteContextProvider>
	</ApolloProvider>
);

export const wrapPageElement = ({ element }: {element: ReactNode}) => (
	<Framework>
		<AnimatePresence mode='sync' initial={false}>{element}</AnimatePresence>
	</Framework>
);